export default "__VITE_ASSET__YK2q_Lw3__"